import React from 'react';
import {
  Text,
  View,
} from 'react-native';
import {
  Bank_1234567_8,
  Bank_name_str,
  Your_account_str,
} from '../../../../utils/DictionaryManagementUtils';
import { textPrimary_9_3, textSecondary_7_5 } from './TextStyle';
//= ========================================================================

const ParagraphWithSmallSubTitle = ({
  globJSON, simPlatform,
}) => {
  const { colors } = globJSON.configurations.theme;
  const myStyles = {
    containerStyle: {
      width: 198,
      height: 31,
      borderRadius: globJSON.configurations.theme.radius.elements_shape_square ? 3 : 9,
      backgroundColor: colors.light_elements_color,
      paddingVertical: 3,
      paddingHorizontal: 9,
    },
    secondaryTextStyle: {
      paddingVertical: 3,
      height: 12,
    },
  };
  return (
    <View
      style={myStyles.containerStyle}
    >
      <Text
        style={[textSecondary_7_5(globJSON, simPlatform), myStyles.secondaryTextStyle]}
      >
        {Your_account_str}
      </Text>
      <Text
        style={[textPrimary_9_3(globJSON, simPlatform), { fontFamily: null }]}
      >
        {Bank_1234567_8}
        {' '}
        {Bank_name_str}
      </Text>
    </View>
  );
};
export default ParagraphWithSmallSubTitle;
